import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ListeComponent } from '../liste/liste.component';
import { GeneralService } from '../services/general.service';
declare var $ : any;
@Component({
  selector: 'app-content-manager',
  templateUrl: './content-manager.component.html',
  styleUrls: ['./content-manager.component.scss']
})
export class ContentManagerComponent implements OnInit 
{

  constructor(public generaleService : GeneralService) { }
  dsLanguage;
  editorConfig: AngularEditorConfig = JSON.parse(JSON.stringify(this.generaleService.editorConfig)) ;
  
  textFr : string = "";
  textEn : string = "";

  dsFile;
  srcImage : string = "assets/icon.png";
  @ViewChild("listeTextComponen") listeTextComponen  : ListeComponent
  columnsText=
  {
    "TableRD":
    [
      {"TableRE_Code":"","TableRD_Champs":"Lg_LibelleFr","Lg_Code":"","TableRD_Des":"Text AR","TableRD_Largeur":150,"TableRD_ReadOnly":true,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":2,"TableRD_Type":7,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"Lg_LibelleEn","Lg_Code":"","TableRD_Des":"Text FR","TableRD_Largeur":150,"TableRD_ReadOnly":true,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":3,"TableRD_Type":7,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null}
    ]
  }
  listeLanges = []
  listeText = [];
  listePage = 
  [
    {text : "Qui Sommes Nous",value : "about-"},
    {text : "Contact",value : "contact-"},
    {text : "aide choix pointure",value : "choix-pointure-"},
    {text : "Cartes cadeaux",value : "cartes-cadeaux-"},
    {text : "Wishlist",value : "wishlist-"},
  ]
  fenetre : string = "";
  code : string;
  listeImages = [];
  listeImagesToshow = [];
  file;
  reader;
  selectedImage;
  ngOnInit() 
  {
    // for(let i=20324;i<20336;i++)
    // {
    //   this.generaleService.supprimerSanMsgConfirm(i,"avtFiles").subscribe(d=>{})
    // }
    // for(let i=8331;i<8345;i++)
    // {
    //   this.generaleService.supprimerSanMsgConfirm(i,"lg").subscribe(d=>{})
    // }   
    // this.generaleService.supprimerSanMsgConfirm(8304,"lg").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(8308,"lg").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(8309,"lg").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(8317,"lg").subscribe(d=>{})

    // this.generaleService.supprimerSanMsgConfirm(8318,"lg").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(8322,"lg").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(8319,"lg").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(8321,"lg").subscribe(d=>{})

    // this.generaleService.supprimerSanMsgConfirm(8324,"lg").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(8327,"lg").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(8329,"lg").subscribe(d=>{})

    // this.generaleService.supprimerSanMsgConfirm(20336,"avtFiles").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(20338,"avtFiles").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(20340,"avtFiles").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(20342,"avtFiles").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(20352,"avtFiles").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(1608129761396,"ecBlogD").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(1607960519847,"ecBlogD").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(1608126608682,"ecBlogD").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(1608126511193,"ecBlogD").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(1608126295311,"ecBlogD").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(1608125822976,"ecBlogD").subscribe(d=>{})
    // this.generaleService.supprimerSanMsgConfirm(1608125787482,"ecBlogD").subscribe(d=>{})
    this.editorConfig.height = "150px";
    this.editorConfig.width = "500px";
    this.getLg(false)
    this.getListeImage()
    // this.generaleService.getDsFile()
  }
  ajouter()
  {
    this.generaleService.enregistrerLanguage(this.code,"0",this.textFr);
    this.generaleService.enregistrerLanguage(this.code,"1",this.textEn);
  }
  async enregistrer()
  {
    if(this.listeTextComponen.row)
    {
      var listeDinstincteCode = this.listeLanges.filter(lg => {return lg.Lg_Code == this.listeTextComponen.row.Lg_Code})
      if(listeDinstincteCode.length == 2)
      {
        this.generaleService.disabled = true;
        var fr,en;
        fr = listeDinstincteCode.find(lst =>{return lst.Lg_Langue == 0});
        en = listeDinstincteCode.find(lst =>{return lst.Lg_Langue == 1});
        if(fr)
        {
          await this.generaleService.modifierLanguage(fr.Lg_Id,this.textFr)
          fr.Lg_Libelle = this.textFr;
        }
        if(en)
        {
          await this.generaleService.modifierLanguage(en.Lg_Id,this.textEn)
          en.Lg_Libelle = this.textEn
        }
        this.generaleService.dialogSuccess("Enregistrer",true);
        this.getLg(true)
      }
    }
   else
    this.generaleService.dialogSuccess("Veuillez sélectionner une ligne",false)
    
  }
  getLg(setDataListe : boolean)
  {
    this.generaleService.rechercheTable("recherche/tbdata?tablere=lgweb").subscribe(data =>
    {
      this.listeLanges = data;
      if(setDataListe)
        this.setDataListe();
    })
  }
  setDataListe()
  {
    this.selectedImage = null;
    this.listeText = []
    var liste = this.listeLanges.filter(lg => {return lg.Lg_Code.indexOf(this.fenetre)>-1})
    var distincteCode = this.generaleService.distinct(liste, "Lg_Code")
    distincteCode.forEach(row =>
    {
      var listeDinstincteCode = liste.filter(lg => {return lg.Lg_Code == row})
      if(listeDinstincteCode.length == 2)
      {
        var fr,en;
        fr = listeDinstincteCode.find(lst =>{return lst.Lg_Langue == 0});
        en = listeDinstincteCode.find(lst =>{return lst.Lg_Langue == 1});
        this.listeText.push({Lg_LibelleFr : (fr ? fr.Lg_Libelle : ""), Lg_LibelleEn : (en ? en.Lg_Libelle : ""),Lg_Code : row})
      }
        
    });
    this.listeTextComponen.setDataSource(this.listeText);
    this.listeImagesToshow = this.listeImages.filter(img => {return img.File_Groupe == this.fenetre});
    this.generaleService.disabled = false;
  }
 
  onChangeImagefile(fileInput)
  {   
    var current_file = fileInput.target.files[0];
    var reader = new FileReader();
    if (current_file.type.indexOf('image') == 0) 
    {
      reader.onload =  (e) =>
      {
        this.reader = reader;

        if(this.selectedImage)
        {
          this.selectedImage.File_Content = reader.result.toString();
          this.saveImage()
        }
      }
      reader.readAsDataURL(current_file);
      
    }
    else
      this.generaleService.dialogSuccess("Veuillez sélectionner une image",false)
  }
  saveImage()
  {
    this.generaleService.disabled = true
    this.generaleService.rechercheTable(this.generaleService.urlFiles+"&val="+this.selectedImage.File_Id.toString()).subscribe(data =>
    {
      data.Files[0].File_Content = this.reader.result.toString();
      this.generaleService.enregisterTable(data).subscribe(data =>
      {
        this.generaleService.disabled = false;
        this.generaleService.dialogSuccess("Enregistrer",true)
      })
    })
  }
  clickBtnHeat(event)
  {
    switch (event.name)
    {      
      case "selectRow":
      {
        this.textEn = event.row.Lg_LibelleEn
        this.textFr = event.row.Lg_LibelleFr
        break;
      }
    }
  }
  getListeImage()
  {
    this.listeImages = [];
    this.generaleService.rechercheTable(this.generaleService.url+ "avtFilesType&param=CONTENT-MANAGER").subscribe( img =>
    {
      this.listeImages = img;
     
      this.getImageContent()
    });
  }
  getImageContent()
  {
    for(let i=0;i< this.listeImages.length;i++)
    {
      this.generaleService.rechercheTable(this.generaleService.urlFiles+"&val="+ this.listeImages[i].File_Id).subscribe( file =>
      {
        this.listeImages[i].File_Content =file.Files[0].File_Content;
      });
    }
  }
  enregistrerImage()
  {
    if(this.file && this.fenetre && this.code)
    {
      this.generaleService.disabled = true;
      this.generaleService.addFiles(
        this.reader.result.toString(),
      "",
      this.code,
      "CONTENT-MANAGER","","",this.fenetre,"")

    }
    
    else
    this.generaleService.dialogSuccess("Saisir tous les champs",false)
  }
  openFrmImage(image)
  {
    document.getElementById('input_file').click();
    this.selectedImage = image;   
    for(var i=1;i<this.listeImagesToshow.length+1;i++)
    {
      $("#"+this.listeImagesToshow[0].File_Id).attr("style","");
    }
    $("#"+image.File_Id).attr("style","border-color: blue;   border-style: solid;");
  }
  
  
}
